"use client";

import { type MouseEventHandler, type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { useSingleton } from "@/singletons/abstract.singleton";
import { clickSingleton } from "@/singletons/click.singleton";
import { TYPO_STYLES } from "@/styles/typography";

export const SearchModuleCategoriesView = ({ children }: PropsWithChildren) => {
    useSingleton(clickSingleton);

    const openClasses = clickSingleton.isOpened() ? "block" : "hidden md:block";

    const handleClose: MouseEventHandler<HTMLElement> = (e) => {
        if (e.target === e.currentTarget) {
            clickSingleton.toogle();
            clickSingleton.notify();
        }
    };

    return (
        <aside
            className={twMerge(
                openClasses,
                "size-full fixed right-0 top-0 z-50 md:static md:col-span-1 md:z-0 bg-modalBackground md:bg-transparent h-full md:h-auto min-w-[300px] md:w-auto",
            )}
        >
            <div
                className={twMerge(
                    "bg-white absolute md:static h-full min-w-[300px] right-0 rounded-l-3xl md:rounded md:min-w-full pt-14 md:pt-6 overflow-auto",
                )}
            >
                <p className={twMerge(TYPO_STYLES.headlineExtraBold4(), "px-6 py-2")}>Kategorie</p>
                <button
                    onClick={handleClose}
                    className={twMerge(
                        "absolute right-3 top-3 p-2 md:hidden text-2xl",
                        TYPO_STYLES.icon(),
                    )}
                >
                    {String.fromCharCode(Number(`0xe91b`))}
                </button>
                <ul className="search-page-category">{children}</ul>
            </div>
        </aside>
    );
};
